import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-table-header-buttons',
  templateUrl: './table-header-buttons.component.html',
  styleUrls: ['./table-header-buttons.component.scss']
})
export class TableHeaderButtonsComponent implements OnInit {

  @Input() selectedCountElements: number;
  @Input() searchValue: string;
  @Output() addButtonClick = new EventEmitter();
  @Output() removeButtonClick = new EventEmitter();
  @Output() editButtonClick = new EventEmitter();
  @Output() searchValueChanged = new EventEmitter();

  constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

  addClick() {
    this.addButtonClick.emit();
  }

  removeClick(){
    this.removeButtonClick.emit();
  }

  editClick(){
    this.editButtonClick.emit();
  }

  onSearch(value){
    this.searchValueChanged.emit(value);
  }
}
